/*
* Track user interactions
*/
(function (window, runtime, config) {

    runtime.initInteractionManager = function ($, _) {
        var interactionManager = runtime.interactionManager || {};

        var $document = $(document);
        var that = this;
        var interactionsStorage = {
            store: [],
            isSending: false,
            lastIndex: null,
            set: function (interaction) {
                if (that.inStudio) {
                    return;
                }
                if (_.isArray(interaction)) {
                    this.store.concat(interaction)
                } else {
                    this.store.push(interaction);
                }
                this.onChange();
            },
            onChange: function () {
                if (this.store.length >= config.BULK_SIZE) {
                    this.uploadInteractions();
                }
            },
            uploadInteractions: function () {
                if (!this.store.length || this.isSending) {
                    return;
                }
                this.isSending = true;
                this.lastIndex = this.store.length;
                var self = this;
                runtime
                    .uploadInteractions(this.store.slice(0, this.lastIndex))
                    .then(
                    // _.noop, // TODO uncomment after interaction feature implementation
                    function (xhr) {
                        // if (xhr.status === 200) {
                        //     // Clear part of store if success
                        //     self.store.splice(0, self.lastIndex);
                        // }
                        self.store.splice(0, self.lastIndex);
                        self.isSending = false;
                        self.lastIndex = null;
                    }
                );
            },
            getAllInteractions: function () {
                return this.store.slice();
            },
            getNotSentInteractions: function () {
                return this.store.slice(this.lastIndex || 0);
            }
        };

        config = _.defaults(config || {}, {
            BULK_SIZE: 25,
            AJAX_INTERVAL: 0.5 * 60 * 60,
            GLOBAL_EVENTS: [
                {
                    eventName: 'mouseover',
                    throttle: 100,
                    debounce: false,
                    fn: function () {
                        // TODO global mouseover handler
                    }
                },
                {
                    eventName: 'click',
                    throttle: false,
                    debounce: false,
                    fn: function () {
                        // TODO global click handler
                    }
                }
            ]
        });

        interactionManager.handlers = {
            _handlers: {},

            defaultHandler: {
                fn: function () {
                    if (runtime.flags.debug) {
                        console.warn('Default handler was not defined');
                    }
                },
                options: {
                    throttle: false,
                    debounce: false
                }
            },

            getHandler: function (eventName) {
                var handlerObj = this._handlers[eventName];

                return handlerObj
                    ? _.bind(handlerObj.fn, handlerObj.ctx)
                    : this.defaultHandler;

            },

            wrapHandler: function (handlerFn, options) {
                // Wrap handler into throttle, debounce func.
                if (options.throttle) {
                    return _.throttle(handlerFn, Number(options.throttle));
                }
                if (options.debounce) {
                    return _.debounce(handlerFn, Number(options.debounce));
                }
                return handlerFn;
            },

            registerHandler: function (handlerFn, eventDefinition, ctx) {
                // Register handler for specific events or for components
                if (!eventDefinition || !eventDefinition.eventName) {
                    throw TypeError('EventDefinition should be an object with eventName fields')
                }

                this._handlers[eventDefinition.eventName] = {
                    fn: this.wrapHandler(handlerFn, eventDefinition),
                    ctx: ctx
                };
            }
        };

        interactionManager.pushInteraction = function (interaction) {
            interactionsStorage.set(interaction);
            return interactionManager;
        };

        interactionManager.getAllInteractions = function () {
            return interactionsStorage.getAllInteractions();
        };
        interactionManager.getNotSentInteractions = function () {
            return interactionsStorage.getNotSentInteractions();
        };

        if (!this.inStudio) {
            initGlobalEvents.call(this);
            initAutoSend.call(this);
        }

        function initGlobalEvents() {
            config.GLOBAL_EVENTS.forEach(function (globalEvent) {

                interactionManager.handlers.registerHandler(globalEvent.fn, globalEvent, null);

                // Bind by event name; passing the definition object made jQuery treat it as an
                // events map and bind its string properties as handlers (a silent no-op on
                // jQuery 1.x, a strict-mode TypeError on jQuery 3.x).
                $document.on(globalEvent.eventName, interactionManager.handlers.getHandler(globalEvent.eventName))
            })
        }

        function initAutoSend() {
            setInterval(_.bind(interactionsStorage.uploadInteractions, interactionsStorage), config.AJAX_INTERVAL);
        }
    }

})(window, window.ixp.runtime, window.ixp.runtime.interactionsConfig);
